import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpService} from '../../../common/api/http.service';
import {APIResponse, SimpleMultiSeries, SimpleSeries} from '@core/interfaces/system/system-common';
import {DownloadURL, PeriodFilter} from '@core/interfaces/engin/load-forecast/load-forecast';
import {HttpParams} from '@angular/common/http';
import {DataSource} from '@mominsamir/ngx-smart-table/lib/lib/data-source/data-source';
import {LoadProfileInfo, MeterInfo} from '@core/interfaces/engin/load-forecast/meter';

@Injectable()
export class MeterLoadForecastApi {
    private readonly PREFIX_METER = 'infrastructure/peakload';

    constructor(private api: HttpService) {}

    /*
     * Infrastructure: results for meter(s)
     */
    public getMeterInfo(workflowItemId: number, scenarioId: string, meterId: string): Observable<MeterInfo[]> {
        return this.api.get(`${this.PREFIX_METER}/${workflowItemId}/scenarios/${scenarioId}/meters/${meterId}/info`);
    }

    public getMeterPivot(
        workflowItemId: number,
        scenarioId: string,
        meterId: string,
        period: PeriodFilter,
        seasonIds: string[],
        unit: string,
        sensitivityId: string,
    ): Observable<DataSource> {
        let params = `filterByloadYear_GREATER_THAN_OR_EQUAL=${period.min}`;
        params = params + `&filterByloadYear_LESS_THAN_OR_EQUAL=${period.max}`;
        params = params + `&filterByseasonId_IN=${seasonIds.join('|')}`;
        params = params + `&unit=${unit}`;
        params = params + `&sensitivityId=${sensitivityId}`;
        return this.api.getServerDataSource(
            `${this.PREFIX_METER}/${workflowItemId}/scenarios/${scenarioId}/meters/${meterId}/pivot?${params}`,
        );
    }

    public getMeterPivotCSV(
        workflowItemId: number,
        scenarioId: string,
        meterId: string,
        period: PeriodFilter,
        seasonIds: string[],
        unit: string,
        sensitivityId: string,
    ): Observable<APIResponse<DownloadURL>> {
        return this.api.get(
            `${this.PREFIX_METER}/${workflowItemId}/scenarios/${scenarioId}/meters/${meterId}/pivot/csv`,
            {
                params: new HttpParams()
                    .set('filterByloadYear_GREATER_THAN_OR_EQUAL', period.min)
                    .set('filterByloadYear_LESS_THAN_OR_EQUAL', period.max)
                    .set('filterByseasonId_IN', seasonIds.join('|'))
                    .set('unit', unit)
                    .set('sensitivityId', sensitivityId),
            },
        );
    }

    public getLoadProfileInfo(
        workflowItemId: number,
        scenarioId: string,
        meterId: string,
    ): Observable<LoadProfileInfo> {
        return this.api.get(
            `${this.PREFIX_METER}/${workflowItemId}/scenarios/${scenarioId}/meters/${meterId}/load-profile/info`,
        );
    }

    public getLoadProfileRaw(
        workflowItemId: number,
        scenarioId: string,
        meterId: string,
    ): Observable<SimpleSeries<Date, number>> {
        return this.api.get(
            `${this.PREFIX_METER}/${workflowItemId}/scenarios/${scenarioId}/meters/${meterId}/load-profile/raw`,
        );
    }

    public getLoadProfileTypicalDay(
        workflowItemId: number,
        scenarioId: string,
        meterId: string,
        groupBy: string,
    ): Observable<SimpleMultiSeries<number>> {
        return this.api.get(
            `${this.PREFIX_METER}/${workflowItemId}/scenarios/${scenarioId}/meters/${meterId}/load-profile/typical-day/${groupBy}`,
        );
    }
}
